export default __webpack_public_path__ + "static/doccam_w.79bfb9640e94309eebe4dadd912ee891.png";